/* eslint-disable prettier/prettier */
import React, { useEffect } from "react";

import BillingData from "components/PreferenciaCobranca/BillingData";
import Navbar from "components/MI/Navbar";
import UserMenu from "components/layout/userMenuNew";
import { useTour } from "hooks/useTour";

import TourBalloon from "components/NewTour/TourBallon";
import {
  Body,
  Container,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
} from "./styles";

const PreferenciaCobranca = (): JSX.Element => {
  const { showTour, setTourType, setSteps, tourStep, tourType } = useTour();

  useEffect(() => {
    setTourType("preferencia-cobranca");
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  return (
    <Navbar selected="preferencia-cobranca" openSubMenu>
      <UserMenu intro />
      <Container>
        <Header>
          <HeaderInfos>
            <HeaderTitle>Preferência de cobrança</HeaderTitle>
            <HeaderSubtitle>Verifique seus dados de cobrança.</HeaderSubtitle>
          </HeaderInfos>
        </Header>
        <Body
          showTour={
            tourStep === 1 && tourType === "preferencia-cobranca" && showTour
          }
        >
          <BillingData />
          {showTour && tourStep === 1 && tourType === "preferencia-cobranca" && (
            <TourBalloon
              title="Preferência de cobrança"
              content="Informe a melhor data de vencimento e cadastre sua fatura no digital! Ainda assim, se preferir o envio pelos Correios, informe seu endereço de correspondência."
              position={{
                left: "458px",
                top: "50%",
                arrowPosition: "unset",
                maxWidth: 320,
                boxShadow: true,
                transform: "translateY(-50%)",
              }}
            />
          )}
        </Body>
      </Container>
    </Navbar>
  );
};

export default PreferenciaCobranca;
